import React from "react"
import { navigate } from "gatsby"

import { AirtableApi } from "../../helpers/AirtableApi"

import TwoColumnHeroWithImageRight, {
  CONTAINMENT_MODE,
} from "../_base/TwoColumnHeroWithImageRight"

import { ChildSelector } from "../../helpers/ChildSelector"

import * as registerFormStyles from "../../styles/landing_pages/RegisterForm.module.css"

export default function RegisterForm(props) {
  const { content } = props

  const [, forceUpdate] = React.useReducer(x => x + 1, 0)

  const [isSubmitting, setSubmitting] = React.useState(false)
  const [isSubmitted, setSubmitted] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)

  let location = null
  const locations = props.className
    .split(` `)
    .filter(cn => cn.startsWith(`icw-evt`))
  if (locations.length > 0) {
    location = locations[0].replace(`icw-evt-`, ``).toLowerCase()
  }

  const [data, setData] = React.useState({
    businessEmail: ``,
    firstName: ``,
    lastName: ``,
    company: ``,
    contactNumber: ``,
    jobPosition: ``,
    dietaryRestrictions: ``,
    postEvent: [
      {
        name: `Yes`,
        checked: false,
      },
      {
        name: `No`,
        checked: true,
      },
    ],
  })

  const handleItemChange = (evt, cat) => {
    let updated = data
    if (Object.keys(evt.target).includes(`checked`)) {
      if (cat) {
        updated[cat].map((it, idx) => {
          it.checked = false
        })
        updated[cat].find(({ name }) => name === evt.target.name).checked =
          evt.target.checked
      } else {
        updated[evt.target.name] = evt.target.checked
      }
    } else {
      updated[evt.target.name] = evt.target.value
    }

    setData(updated, forceUpdate())
  }

  const handleSubmit = async evt => {
    evt.preventDefault()

    setHasError(false)
    setSubmitting(true)

    let filteredData = JSON.parse(JSON.stringify(data))
    filteredData[`postEvent`] = data[`postEvent`]
      .reduce((prev, curr) => {
        if (curr.checked) return [...prev, curr.name]
        return prev
      }, [])
      .toString()

    let airtableId = `apphzvs1AVHbJizqo`
    let airtableName = `SydneyRegistration`
    switch (location) {
      case `melbourne`:
        airtableName = `MelbourneRegistration`
        airtableId = ``
        break
      case `sydney`:
        airtableName = `SydneyRegistration`
        airtableId = ``
      case `sydney-2024`:
        airtableName = `SydneyRegistration`
        airtableId = `app8fdMx5BhnHF1dR`
        break
    }

    try {
      const records = await AirtableApi.writeRecord(
        process.env.GATSBY_AIRTABLE_API_TOKEN,
        airtableId,
        airtableName,
        filteredData,
      )

      const record = records && records.records && records.records[0]
      const submittedPage = record && record.fields[`thankYouPage`]

      setHasError(false)
      setSubmitting(false)
      setSubmitted(true)

      navigate(submittedPage)
    } catch (error) {
      console.error(error)

      setHasError(true)
      setSubmitting(false)
    }
  }

  const title = ChildSelector.select(
    content,
    `title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const info = content.childNodes
    .filter(node => node.classNames === "text")
    .map(t => t.innerHTML)

  return (
    <>
      <div className={`row ${registerFormStyles.wrapper}`}>
        <TwoColumnHeroWithImageRight
          contentClass={registerFormStyles.content}
          imageHolder={content}
          imageSelector={`media`}
          imageClass={registerFormStyles.backgroundImage}
          className={registerFormStyles.columnWrapper}
          mode={CONTAINMENT_MODE.normal}
        >
          <div
            id={props.componentOriginalId || ``}
            className={`row ${registerFormStyles.formSubmitWrapper}`}
          >
            <div className={`col ${registerFormStyles.formSubmit}`}>
              <h2>{title}</h2>
              {info.map((t, idx) => (
                <p
                  dangerouslySetInnerHTML={{ __html: t }}
                  className={registerFormStyles.main}
                  key={idx}
                />
              ))}

              <form
                className={`row ${registerFormStyles.form}`}
                onSubmit={handleSubmit}
              >
                <div className={`col ${registerFormStyles.personalInfo}`}>
                  <label>First Name *</label>
                  <input
                    id="firstName"
                    type="text"
                    className="form-control"
                    name="firstName"
                    value={data.firstName}
                    required
                    pattern="\S(.*\S)?"
                    onChange={handleItemChange}
                  />
                </div>
                <div className={`col ${registerFormStyles.personalInfo}`}>
                  <label>Last Name *</label>
                  <input
                    id="lastName"
                    type="text"
                    className="form-control"
                    name="lastName"
                    value={data.lastName}
                    required
                    pattern="\S(.*\S)?"
                    onChange={handleItemChange}
                  />
                </div>
                <div className={`col ${registerFormStyles.personalInfo}`}>
                  <label>Company *</label>
                  <input
                    id="company"
                    type="text"
                    className="form-control"
                    name="company"
                    value={data.company}
                    required
                    pattern="\S(.*\S)?"
                    onChange={handleItemChange}
                  />
                </div>
                <div className={`col ${registerFormStyles.personalInfo}`}>
                  <label>Email *</label>
                  <input
                    id="businessEmail"
                    type="email"
                    className="form-control"
                    aria-label="Email"
                    name="businessEmail"
                    value={data.businessEmail}
                    required
                    pattern="\S(.*\S)?"
                    onChange={handleItemChange}
                  />
                </div>
                <div className={`col ${registerFormStyles.personalInfo}`}>
                  <label>Job Position *</label>
                  <input
                    id="jobPosition"
                    type="jobPosition"
                    className="form-control"
                    aria-label="JobPosition"
                    name="jobPosition"
                    value={data.jobPosition}
                    required
                    pattern="\S(.*\S)?"
                    onChange={handleItemChange}
                  />
                </div>
                {location === `melbourne` && location !== `sydney` && (
                  <div className={`col ${registerFormStyles.personalInfo}`}>
                    <label>Contact Number *</label>
                    <input
                      id="contactNumber"
                      type="contactNumber"
                      className="form-control"
                      aria-label="ContactNumber"
                      name="contactNumber"
                      value={data.contactNumber}
                      required
                      pattern="\S(.*\S)?"
                      onChange={handleItemChange}
                    />
                  </div>
                )}
                <div className={`col ${registerFormStyles.message}`}>
                  <label htmlFor="dietaryRestrictions">
                    Do you have any dietary restrictions or special dietary
                    preferences? If so, please let us know in the box below.*
                  </label>
                  <textarea
                    className="form-control"
                    name="dietaryRestrictions"
                    rows="3"
                    required
                    pattern="\S(.*\S)?"
                    values={data.dietaryRestrictions}
                    onChange={handleItemChange}
                  ></textarea>
                </div>
                <div className={`col ${registerFormStyles.notes}`}>
                  <label htmlFor="postEvent">
                    Will you be joining us for post-event networking from 5:30
                    pm onwards? *
                  </label>
                  <div className={`col-6 ${registerFormStyles.optionsWrapper}`}>
                    {data.postEvent.map((it, idx) => (
                      <div
                        key={idx}
                        className={`col ${registerFormStyles.options}`}
                      >
                        <input
                          className="form-check-input"
                          type="radio"
                          name={it.name}
                          checked={data.postEvent[idx].checked}
                          onChange={evt => handleItemChange(evt, `postEvent`)}
                        />
                        <label className="form-check-label">{it.name}</label>
                      </div>
                    ))}
                  </div>
                </div>
                <div className={`col ${registerFormStyles.info}`}>
                  <p>All fields are mandatory *</p>
                </div>
                <div className={`col ${registerFormStyles.validation}`}>
                  <input
                    id="invalidCheck"
                    type="checkbox"
                    className="form-check-input"
                    required
                    pattern="\S(.*\S)?"
                  />
                  <label>
                    We would like your permission to reach out to you with more
                    information about our products and services. We will only
                    send you marketing information we think will be relevant to
                    you. We will always treat your personal details with the
                    utmost care and will never sell them to other companies for
                    marketing purposes.
                  </label>
                </div>
                <div className={`row ${registerFormStyles.submitSection}`}>
                  <div className={`col ${registerFormStyles.submitBtn}`}>
                    {!isSubmitting && (
                      <button
                        type="submit"
                        className={`${registerFormStyles.btn}`}
                      >
                        Register
                      </button>
                    )}
                    {hasError && (
                      <p>
                        An unexpected error has occurred. Please confirm all
                        data to be correctly input and try again...
                      </p>
                    )}
                    {isSubmitted && (
                      <p>
                        Thank you for your interest! You will receive an e-mail
                        shortly with a follow up.
                      </p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </TwoColumnHeroWithImageRight>
      </div>
    </>
  )
}
